import { Directive } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[mibiCardActions]'
})
export class MibiCardActionsDirective {}
